// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import {
  StyledModal,
  StyledTitle,
  StyledDescription,
  StyledButtons,
  StyledButton,
  StyledConfirmButton,
} from './DeleteConfirmationModalStyles';

interface IDeleteConfirmationModal {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal = ({ onConfirm, isOpened, onClose }: IDeleteConfirmationModal) => {
  const { t } = useTranslation(['documents']);

  return (
    <StyledModal open={isOpened} onCancel={onClose} footer={null}>
      <StyledTitle>{t('documents_delete_title')}</StyledTitle>
      <StyledDescription>{t('documents_delete_description')}</StyledDescription>
      <StyledButtons>
        <StyledButton onClick={onClose} shape="round">
          {t('documents_delete_back')}
        </StyledButton>
        <StyledConfirmButton onClick={onConfirm} type={'primary'} shape="round">
          {t('documents_delete_confirm')}
        </StyledConfirmButton>
      </StyledButtons>
    </StyledModal>
  );
};

export default DeleteConfirmationModal;
